import React, { useState } from 'react';
import Icon from './Icon';

const PlayerManagement = ({ 
  players, 
  onAddPlayer, 
  onDropPlayer, 
  onRemovePlayer, 
  onBack, 
  tournamentStarted,
  availablePlayers,
  onAddExistingPlayer 
}) => {
  const [name, setName] = useState('');
  const [showAddExisting, setShowAddExisting] = useState(false);

  const handleAdd = () => {
    if (!name.trim()) return;
    onAddPlayer(name.trim());
    setName('');
  };

  const handleAddExisting = (player) => {
    onAddExistingPlayer(player);
    setShowAddExisting(false);
  };

  const playersNotInTournament = availablePlayers?.filter(
    p => !players.some(tp => tp.id === p.id)
  ) || [];

  return (
    <div className="min-h-screen p-4">
      <button onClick={onBack} className="mb-4 text-red-500 flex items-center gap-2">
        <Icon d="M15 19l-7-7 7-7" />
        Retour
      </button>

      <h1 className="text-2xl font-bold mb-4">Joueurs ({players.filter(p => !p.dropped).length})</h1>

      {!tournamentStarted && (
        <div className="mb-6 space-y-3">
          <div className="flex gap-2">
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleAdd()}
              placeholder="Nom du nouveau joueur"
              className="flex-1 bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 focus:outline-none focus:border-red-500"
            />
            <button
              onClick={handleAdd}
              className="bg-red-600 text-white px-6 rounded-lg font-semibold active:bg-red-700"
            >
              <Icon d="M12 4v16m8-8H4" />
            </button>
          </div>

          {playersNotInTournament.length > 0 && (
            <button
              onClick={() => setShowAddExisting(!showAddExisting)}
              className="w-full bg-green-600 text-white py-3 rounded-lg font-semibold flex items-center justify-center gap-2"
            >
              <Icon d="M12 4v16m8-8H4" />
              Ajouter un joueur existant ({playersNotInTournament.length})
            </button>
          )}

          {showAddExisting && (
            <div className="bg-gray-800 rounded-lg p-4 space-y-2">
              <h3 className="font-semibold mb-2">Joueurs disponibles :</h3>
              {playersNotInTournament.map(player => (
                <button
                  key={player.id}
                  onClick={() => handleAddExisting(player)}
                  className="w-full text-left p-3 bg-gray-700 rounded-lg hover:bg-gray-600 transition"
                >
                  {player.name}
                </button>
              ))}
            </div>
          )}
        </div>
      )}

      <div className="space-y-2">
        {players.map(player => (
          <div
            key={player.id}
            className={`bg-gray-800 p-4 rounded-lg flex items-center justify-between ${player.dropped ? 'opacity-50' : ''}`}
          >
            <div>
              <div className="font-semibold">{player.name}</div>
              <div className="text-sm text-gray-400">
                {player.matchWins}-{player.matchLosses}-{player.matchDraws} • {player.matchPoints} pts
              </div>
            </div>
            <div className="flex gap-2">
              {!player.dropped && tournamentStarted && (
                <button
                  onClick={() => onDropPlayer(player.id)}
                  className="text-yellow-500 font-semibold px-3 py-1 rounded border border-yellow-500"
                >
                  Drop
                </button>
              )}
              {!tournamentStarted && (
                <button
                  onClick={() => onRemovePlayer(player.id)}
                  className="text-red-500 font-semibold px-3 py-1 rounded border border-red-500"
                >
                  Retirer
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      {players.length === 0 && (
        <div className="text-center text-gray-400 mt-8">
          <Icon d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" className="w-16 h-16 mx-auto mb-4 opacity-50" />
          <p>Aucun joueur inscrit</p>
          <p className="text-sm">Ajoutez des joueurs pour commencer le tournoi</p>
        </div>
      )}
    </div>
  );
};

export default PlayerManagement;